import { createContext } from 'react';
/** 默认的 Transition CSS 类名前缀 */
export var DEFAULT_TRANSITION_PREFIX = 'bcz-transition-';
/** 默认的长度单位 */
export var DEFAULT_LENGTH_UNIT = 'vw';
/** 默认的视窗宽度 */
export var DEFAULT_VIEWPORT_WIDTH = 375;
/** 默认的动画时间函数 */
export var DEFAULT_TIMING_FUNCTION = 'ease';
/** 默认的动画入场持续时长 */
export var DEFAULT_ENTER_TIMEOUT = 300;
/** 默认的动画离场持续时长 */
export var DEFAULT_EXIT_TIMEOUT = DEFAULT_ENTER_TIMEOUT;
export var TransitionConfigContext = createContext({
    transitionPrefix: DEFAULT_TRANSITION_PREFIX,
    lengthUnit: DEFAULT_LENGTH_UNIT,
    viewportWidth: DEFAULT_VIEWPORT_WIDTH,
    timingFunction: DEFAULT_TIMING_FUNCTION,
    enterTimeout: DEFAULT_ENTER_TIMEOUT,
    exitTimeout: DEFAULT_EXIT_TIMEOUT,
});
